(function () {
    'use strict';

    angular.module('app').controller('AccountingCustomerSettingsModalController', AccountingCustomerSettingsModalController);

    AccountingCustomerSettingsModalController.$inject = [
        'AccountingService',
        '$uibModalInstance',
        'toastr',
        'ClientService',
        'settingsData',
    ];

    function AccountingCustomerSettingsModalController(
        AccountingService,
        $uibModalInstance,
        toastr,
        ClientService,
        settingsData,
    ){
        const vm = this;
        vm.loading = true;
        vm.billingFrequencies = [
            { value: 'daily', text: 'Daily' },
            { value: 'weekly', text: 'Weekly' },
            { value: 'semi_monthly', text: 'Semi-Monthly' },
            { value: 'monthly', text: 'Monthly' },
            { value: 'quarterly', text: 'Quarterly' },
            { value: 'semi_annual', text: 'Semi-Annual' },
            { value: 'annual', text: 'Annual' }
        ];

        vm.inputIsValid = inputIsValid;
        vm.save = save;
        vm.cancel = cancel;
        //defualt select data function
        vm.test =  vm.billingFrequencies.find(data => {
            return data.value.toLowerCase();
        })

        vm.onSelectBillingFrequency = onSelectBillingFrequency
        init();
        function init() {
            getCompanies();
            if (settingsData !== null) {
                initSettingsData(settingsData);
                onSelectBillingFrequency(vm.test)
            }
           
        }

        function getCompanies() {
            ClientService.Company.getAll(success => {
                vm.customers = success.content;
            }, error => {
                toastr.error("Error", error.message);
            });
        }

        function initSettingsData(settings) {
            vm.settings = {
                id: settings.id,
                automaticBilling: settings.automaticBilling || false,
                billingFrequency: vm.billingFrequencies.find(data => {
                    return data.value.toLowerCase() == settings.billingFrequency.toLowerCase();
                }),
                customer: settings.customer !== null ? settings.customer : { name: `${settings.company.name} (Global Settings)`, id: null },
                cycleStartDate: settings.cycleStartDate,
                dueDate: settingsData.dueDate
            }

            vm.settingsRaw = angular.copy(vm.settings);
        }

        function onSelectBillingFrequency(billingFrequency) {
            switch (billingFrequency.value) {
                case 'daily':
                    vm.settings.cycleStartDate  = 1
                    vm.settings.dueDate = 1
                    vm.disableDaySelection = true;
                    break;
                case 'weekly':
                    vm.disableDaySelection = false;
                    vm.settings.cycleStartDate = null;
                    vm.settings.dueDate = null;
                    break;
                case 'semi_monthly':
                    vm.disableDaySelection = false;
                    vm.settings.cycleStartDate = null;
                    vm.settings.dueDate = null;
                    break;
                case 'monthly':
                    vm.disableDaySelection = false;
                    if (settingsData !== null) {
                        vm.settings = vm.settingsRaw;
                    }
                    break;
                case 'quarterly':
                    vm.disableDaySelection = false;
                    if (settingsData !== null) {
                        vm.settings = vm.settingsRaw;
                    }
                    break;
                case 'semi_annual':
                    vm.disableDaySelection = false;
                    if (settingsData !== null) {
                        vm.settings = vm.settingsRaw;
                    }
                    break;
                case 'annual':
                    if (settingsData !== null) {
                        vm.settings = vm.settingsRaw;
                    }
                    break;
            }
        }

        function inputIsValid(input) {
            return (vm.carrierSettingsForm.$submitted || input.$touched) && input.$invalid;
        }

        function save() {
            vm.carrierSettingsForm.$setSubmitted();
            if(vm.carrierSettingsForm.$invalid) {
                return false;
            }

            vm.saveInProgress = true;
            const payload = {
                automaticBilling: vm.settings.automaticBilling !== undefined ? vm.settings.automaticBilling : false,
                billingFrequency: vm.settings.billingFrequency.value,
                cycleStartDate: vm.settings.cycleStartDate || 1,
                dueDate: vm.settings.dueDate || 1, 
                customerId: vm.settings.customer.id !== null ? Number(vm.settings.customer.id) : null,
            }

            if (settingsData !== null) {
                AccountingService.CustomersBillingSettings.update(success => {
                    toastr.success('Customer Billing Settings Updated!');
                    vm.saveInProgress = false;
                    $uibModalInstance.close();
                }, error => {
                    toastr.error(error.message || 'Please try again', 'Failed to save customer billing settings');
                    vm.saveInProgress = false;
                }, payload, vm.settings.id);
            } else {
                AccountingService.CustomersBillingSettings.addNew(success => {
                    toastr.success('Customer Billing Settings Saved!'); 
                    vm.saveInProgress = false; 
                    $uibModalInstance.close();
                }, error => {
                    toastr.error(error.message || 'Please try again', 'Failed to save customer billing settings')
                }, payload);
            }
        }

        function cancel() {
            $uibModalInstance.dismiss();
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/accounting/AccountingCustomerSettingsModalController.js